export const zahtjev_ispravak_dopuna= {
  templateId: 93,
  category: 9,
  templateTitle: "Zahtjev ispitanika za ispravak/dopunu osobnih podataka - GDPR",
  templateDescription: `<p>Zahtjev za ispravak ili dopunu osobnih podataka je pravo ispitanika koje proizlazi iz Uredbe, čije nepoštivanje od strane voditelja obrade je kažnjivo.</p>`,
  description: `
    <h5>OPIS  DOKUMENTA</h5>
    <p>Ispitanik ima pravo bez nepotrebnog odgađanja ishoditi od voditelja obrade ispravak netočnih osobnih podataka koji se na njega odnose.</p>
    <p>Napomena: ovaj dokument se ispunjava tek nakon ispisa na pisaču.</p>
    
    <h5>PRAVNA OSNOVA</h5>
    <p>UREDBA (EU) 2016/679 EUROPSKOG PARLAMENTA I VIJEĆA od 27. travnja 2016. o zaštiti pojedinaca u vezi s obradom osobnih podataka i o slobodnom kretanju takvih podataka te o stavljanju izvan snage Direktive 95/46/EZ (Opća uredba o zaštiti podataka).</p>
    `,
    sides: [
      {
          prefix: 'Na temelju Opće uredbe o zaštiti podataka,',

          signature: "Podnositelj zahtjeva:",
            inputs: [{
              type: "input",
              required: true,
              placeholder: "Ime i prezime",
            },
            {
              type: "input",
              required: false,
              placeholder: "Ulica i kućni broj",
            },
            {
              type: "input",
              required: false,
              placeholder: "Mjesto",
            },
            ],
      }
  ],

  headline: "podnosim sljedeći",
  title: "ZAHTJEV ZA ISPRAVAK/DOPUNU OSOBNIH PODATAKA",

  noArticleNumbers: true,

  articles: [  
    
    {
      title: "",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
                    { type: "text", content: "1. VODITELJ OBRADE:\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "NAZIV: _________________________\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "SJEDIŠTE: _________________________\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "ADRESA: _________________________\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "OIB: _________________________"},
        
          ],
        }
      ]
    },
    {
      title: "",
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
                    { type: "text", content: "2. PODACI KOJE JE POTREBNO ISPRAVITI ILI DOPUNITI:\r\n\r\n"},
                    { type: "text", newline:"true", content: "" },
                    { type: "text", newline:"true", content: "________________________________________________________________________"},               
          ],
        }
      ]
    },
 
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
    }
  ],
};


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/93_zahtjev_ispravak_dopuna.ts